// index.js
import React, { Suspense, useEffect, useState, useRef } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import routeConfig from "./routes/routeConfig";
import PrivateRoute from "./routes/privateRoute";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme/theme";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import CSS
import "./App.css";
import { Box, CircularProgress } from "@mui/material";
import { get } from "./services/apiService";
import DashboardLayout from "./components/layout/DashboardLayout";
import HomePreview from "./pages/content/home/HomePreview";
import AboutUsPreview from "./pages/content/about-us/AboutUsPreview";
import FeaturesPreview from "./pages/content/features/FeaturesPreview";
import ContactUsPreview from "./pages/content/contact-us/ContactUsPreview";
import FooterPreview from "./pages/content/footer/FooterPreview";
import content from "./assets/images/dashboard/content.png";
import contentActive from "./assets/images/dashboard/content-active.png";
import { AuthProvider } from "./hooks/useAuth";

// {
//   path: "/content/home",
//   title: "Home Preview",
//   component: HomePreview,
//   layout: DashboardLayout,
//   private: false,
// },
// {
//   path: "/content/about-us",
//   title: "About us Preview",
//   component: AboutUsPreview,
//   layout: DashboardLayout,
//   private: false,
// },
// {
//   path: "/content/features",
//   title: "Features Preview",
//   component: FeaturesPreview,
//   layout: DashboardLayout,
//   private: false,
// },
// {
//   path: "/content/contact-us",
//   title: "Contact Us Preview",
//   component: ContactUsPreview,
//   layout: DashboardLayout,
//   private: false,
// },
// {
//   path: "/content/footer",
//   title: "Footer Preview",
//   component: FooterPreview,
//   layout: DashboardLayout,
//   private: false,
// },

function App() {
  const isPageReloadedRef = useRef(false);

  const [contentRoutes, setContentRoutes] = useState([]);
  const [contentMenu, setContentMenu] = useState({});
  const userId = localStorage.getItem("userId");
  const [isLoading, setIsLoading] = useState(false);
  const [tenantId, setTenantId] = useState("");
  const location = useLocation();

  const onLoading = () => {};

  const fetchSectionsByUserId = async () => {
    if (userId) {
      console.log('need to fetch sections list------------->');
        setIsLoading(true); // only true if it was page reload
      
     
      const response = await get(`users/${userId}/section/list`, {}, onLoading);
      console.log('response---------------->', response);
      if(response?.data?.length > 0) {
        const tenantId = response?.data[0].tenantId;
        console.log('tenant id-------------------------->', tenantId);
        setTenantId(tenantId);
      }

      let contentSections = response?.data?.map((row) => {
        return {
          sectionId: row.id,
          sectionName: row.sectionName,
        };
      });
      contentSections = contentSections?.filter(
        (section) => section?.sectionName !== "Plan"
      );
      const contentNavigation = contentSections?.map((section) => ({
        label: section.sectionName,
        link: `/content/${section.sectionName.toLowerCase().replace(/\s+/g, "-")}/${section.sectionId}`,
      }));
      const contentObject = {
        label: "Content",
        icon: content,
        activeIcon: contentActive,
        link: "",
        children: contentNavigation,
      };
      setContentMenu(contentObject);

      const contentData =
        contentSections &&
        contentSections.map((contentSection) => {
          return {
            path: `/content/${contentSection.sectionName.toLowerCase().replace(/\s+/g, "-")}/:id`,
            private: true,
            title: `${contentSection.sectionName} Preview`,
            layout: DashboardLayout,
            component:
              contentSection.sectionName.includes("Slider") ||
              contentSection.sectionName.includes("Home")
                ? HomePreview
                : contentSection.sectionName.includes("About")
                  ? AboutUsPreview
                  : contentSection.sectionName.includes("Features")
                    ? FeaturesPreview
                    : contentSection.sectionName.includes("Contact")
                      ? ContactUsPreview
                      : FooterPreview,
          };
        });
      // {
      //   label: "Dashboard",
      //   icon: dashboard,
      //   activeIcon: dashboardActive,
      //   link: "/dashboard",
      // },

      setContentRoutes(contentData);
      if (isPageReloadedRef.current) {
        isPageReloadedRef.current = false; // 👈 Reset after first load
      }
      setIsLoading(false); // After loading
     
    }
  };

  useEffect(() => {
    const navigationEntries = performance.getEntriesByType('navigation');
    const isReloaded = navigationEntries.length > 0 && navigationEntries[0].type === 'reload';

    isPageReloadedRef.current = isReloaded; // Save it ONCE
    if(location.pathname !== '/signin') {
    fetchSectionsByUserId();
    }
  }, []);

  useEffect(() => {
    console.log('url is changed and useEffect is called and path name----------->', location.pathname);
    if(location.pathname === '/' && location.pathname !== '/signin') {
      fetchSectionsByUserId();
    }
 
  }, [location.pathname]);


  const mergedRoutes =
    contentRoutes?.length > 0
      ? [...routeConfig, ...contentRoutes]
      : routeConfig;

  return (

    <div >
    {/* <Router> */}
        {isLoading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Suspense
            fallback={
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <CircularProgress />
              </Box>
            }
          >
            <Routes>
              {mergedRoutes.map((route, index) => {
                const Component = route.component;
                const Layout = route.layout;
                if (route.private && route.layout) {
                  return (
                    <Route
                      key={index}
                      path={route.path}
                      element={
                        <PrivateRoute>
                          <Layout contentMenu={contentMenu}>
                            <Component  tenantId={tenantId}/>
                          </Layout>
                        </PrivateRoute>
                      }
                    />
                  );
                } else if (!route.private && route.layout) {
                  return (
                    <Route
                      key={index}
                      path={route.path}
                      element={
                        <Layout contentMenu={contentMenu}>
                          <Component  tenantId={tenantId}/>
                        </Layout> 
                      }
                    />
                  );
                } else {
                  return (
                    <Route
                      key={index}
                      path={route.path}
                      element={<Component />}
                    />
                  );
                }
              })}
            </Routes>
          </Suspense>
        )}
      {/* </Router> */}
      </div>
  );
}

const Root = () => (
  <ThemeProvider theme={theme}>
  <AuthProvider>
    <CssBaseline /> {/* Optional: Provides a consistent baseline for MUI */}
    {/* <GlobalStyles /> */}
    {/* <I18nextProvider i18n={LocalesConfig}> */}

    <Router> {/* 👈 Router must be here */}
        <App />
      </Router>
    <ToastContainer
      position="top-right" // Position of the toast
      autoClose={3000} // Auto close after 3 seconds
      hideProgressBar={false} // Show progress bar
      newestOnTop={true} // Newest toast appears on top
      closeOnClick // Close toast when clicked
      rtl={false} // Right-to-left support
      pauseOnFocusLoss // Pause toast when window loses focus
      draggable // Allow toast to be draggable
      pauseOnHover // Pause toast when hovered
      theme="light" // Theme of the toast (light/dark/colored)
    />
    </AuthProvider>
    {/* </I18nextProvider> */}
  </ThemeProvider>
);

export default Root;
